import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { ModalCardComponent } from '@components/Modals/modal-card/modal-card.component';

@Component({
  selector: 'app-modal-clear-cache',
  standalone: true,
  imports: [ModalCardComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './modal-clear-cache.component.html',
})
export class ModalClearCacheComponent {
  title = input.required<string>();
  subtitle = input<string | null>(null);
  cancelLabel = input.required<string>();
  confirmLabel = input.required<string>();

  cancelClick = output<void>();
  confirmClick = output<void>();
}
